import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "server",
  "use": "server-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"server\"><path d=\"M16 3C10.53 3 5 4.55 5 7.5V24c0 2.95 5.53 4.5 11 4.5S27 27 27 24V7.5C27 4.55 21.47 3 16 3zm0 2c5.58 0 9 1.62 9 2.5S21.58 10 16 10 7 8.38 7 7.5 10.42 5 16 5zm9 19c0 .88-3.42 2.5-9 2.5S7 24.88 7 24v-2.8a7.88 7.88 0 00.77.38l.23.09c.22.09.44.18.68.26l.23.08.9.26A25.27 25.27 0 0016 23a25.27 25.27 0 006.13-.71l.9-.26.23-.08c.24-.08.46-.17.68-.26l.23-.09a7.88 7.88 0 00.77-.38zm-9-3c-5.58 0-9-1.62-9-2.5v-2.8a7.88 7.88 0 00.77.38l.23.09c.22.09.44.18.68.26l.23.08.9.26a25.27 25.27 0 006.19.73 25.27 25.27 0 006.13-.71l.9-.26.23-.08c.24-.08.46-.17.68-.26l.23-.09a7.88 7.88 0 00.77-.38v2.8C25 19.38 21.58 21 16 21zm0-5.5c-5.58 0-9-1.62-9-2.5v-2.8a7.88 7.88 0 00.77.38l.23.09c.22.09.44.18.68.26l.23.08.9.26A25.27 25.27 0 0016 12a25.27 25.27 0 006.13-.71l.9-.26.23-.08c.24-.08.46-.17.68-.26l.23-.09a7.88 7.88 0 00.77-.38V13c.06.88-3.36 2.5-8.94 2.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/server.svg
// module id = qzUN
// module chunks = 39 44